import {
  TestCourseEntity,
  TestCourseGroupTypeEnum,
} from '@/services/types/license-test-course.type';
import { create } from 'zustand';

interface TestCourseModalStore {
  isOpen: boolean;
  selectedGroup: TestCourseGroupTypeEnum | null;
  selectedTestCourse: TestCourseEntity | null;
  open: (group: TestCourseGroupTypeEnum, testCourse?: TestCourseEntity) => void;
  close: () => void;
  isSidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
}

export const useTestCourseModalStore = create<TestCourseModalStore>((set) => ({
  isOpen: false,
  selectedGroup: null,
  selectedTestCourse: null,
  open: (group, testCourse) =>
    set({ isOpen: true, selectedGroup: group, selectedTestCourse: testCourse }),
  close: () => set({ isOpen: false, selectedTestCourse: null }),
  isSidebarOpen: false,
  openSidebar: () => set({ isSidebarOpen: true }),
  closeSidebar: () => set({ isSidebarOpen: false }),
}));
